<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">画像検索</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)" style="height: calc(75vh - 21px);">
        <wj-tab-panel #tab_KYMW0B00 forcedEnabledMode="true" [(selectedIndex)]="kymw0B00Model.tabSelectIndex">
          <wj-tab>
            <a>通常検索</a>
            <div class="element-column">
              <div class="column-list">
                <label class="list-input-title">Ｐコード</label>
                <div class="list-input-content">
                  <input type="text" class="text-label-normal pcode" id="txti_PCode" [tabindex]="0"
                    forcedEnabledMode="true" plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8"
                    [(ngModel)]="kymw0B00Model.pcode"/>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 650px;">
                  <label class="list-input-title">撮影予定日</label>
                  <div class="list-input-content">
                    <wj-input-date #dtf_PhotoScheduleStart id="dtf_PhotoScheduleStart" format="yyyy/MM/dd"
                      [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate" forcedEnabledMode="true"
                      [(text)]="kymw0B00Model.photoScheduleStart" [tabindex]="0" style="width: 9rem">
                    </wj-input-date>
                    <label>～</label>
                    <wj-input-date #dtf_PhotoScheduleEnd id="dtf_PhotoScheduleEnd" format="yyyy/MM/dd"
                      [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate" forcedEnabledMode="true"
                      [(text)]="kymw0B00Model.photoScheduleEnd" [tabindex]="0" style="width: 9rem">
                    </wj-input-date>
                    <button id="btn_ClearPhotoSchedule" class="btn-tartiary" [tabindex]="0"
                      forcedEnabledMode="true" (click)="eventClearPhotoScheduleHandler()">クリア</button>
                  </div>
                  <label class="list-input-title">画像種類</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_ImageKind" #cmb_ImageKind
                      [subid]="'cmb_ImageKind'" [codeDiv]="'ct366'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.imageKind" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">画像名</label>
                  <div class="list-input-content">
                    <app-text-input id="txti_ImageName" #txti_ImageName
                      [subid]="'txti_ImageName'" [restrict]="'[ -￮]'" [maxChars]="9" [tabindex]="0" style="width: 17rem"
                      [displayCountField]="false" [(ngModel)]="kymw0B00Model.imageName" [forcedEnabledMode]="'true'">
                    </app-text-input>
                  </div>
                  <label class="list-input-title">部門コード</label>
                  <div class="list-input-content">
                    <app-class-code-combo-box id="cmb_ClassCode" #cmb_ClassCode
                      [subid]="'cmb_ClassCode'" [tabindex]="0"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.classCode" style="width: 17rem">
                    </app-class-code-combo-box>
                  </div>
                  <label class="list-input-title">使用開始受注コード</label>
                  <div class="list-input-content">
                    <app-order-text-with-catalog id="txti_StartOrderCode" #txti_StartOrderCode 
                    [subid]="'txti_StartOrderCode'" [tabindex] ="0" [forcedEnabledMode]="'true'" 
                    [(ngModel)]="kymw0B00Model.startOrderCode" (onChangedCatalogId)="kymw0B00Model.startDelivCatalogId = $event">
                    </app-order-text-with-catalog>
                  </div>
                  <label class="list-input-title">請求先名</label>
                  <div class="list-input-content">
                    <app-text-input id="txti_BillingName" #txti_BillingName
                      [subid]="'txti_BillingName'" [restrict]="'[ -￮]'" [maxChars]="20" [tabindex]="0"
                      [displayCountField]="false" [fullOnly]="true" [(ngModel)]="kymw0B00Model.billingName"
                      [forcedEnabledMode]="'true'" style="width: 376px">
                    </app-text-input>
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title" 
                    [style.visibility]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'visible' : 'hidden'">
                    スタジオ</label>
                  <div class="list-input-content" 
                    [style.visibility]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'visible' : 'hidden'">
                    <app-code-combo-box id="cmb_Studio" #cmb_Studio
                      [subid]="'cmb_Studio'" [codeDiv]="'ctp259'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.studio" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">画像種別</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_ImageType" #cmb_ImageType
                      [subid]="'cmb_ImageType'" [codeDiv]="'ct367'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.imageType">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">画像ファイル名</label>
                  <div class="list-input-content">
                    <app-text-input id="txti_ImageFileName" #txti_ImageFileName
                      [subid]="'txti_ImageFileName'" [restrict]="'[ -￮]'" [maxChars]="12" [tabindex]="0"
                      [displayCountField]="false" [(ngModel)]="kymw0B00Model.imageFileName"
                      [forcedEnabledMode]="'true'">
                    </app-text-input>
                  </div>
                  <label class="list-input-title">複数コード登録</label>
                  <div class="list-input-content">
                    <label><input type="checkbox" id="chk_MultipleCode" [(ngModel)]="kymw0B00Model.multipleCode"
                        forcedEnabledMode="true" [tabindex]="0" />含む</label>
                  </div>
                  <label class="list-input-title">使用開始配達企画回(翌週)</label>
                  <div class="list-input-content">
                    <app-catalog-text-with-order id="txti_StartDelivCatalog" 
                      #txti_StartDelivCatalog [subid]="'txti_StartDelivCatalog'" [tabindex]="0" [forcedEnabledMode]="'true'"
                      [(ngModel)]="kymw0B00Model.startDelivCatalogId" (onChangedOrderCode)="kymw0B00Model.startOrderCode = $event">
                    </app-catalog-text-with-order>
                  </div>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 650px;">
                  <label class="list-input-title">商品案内用商品名</label>
                  <div class="list-input-content">
                    <app-text-input id="txti_GuideGoodsName" class="guide-goods-name" #txti_GuideGoodsName
                      [subid]="'txti_GuideGoodsName'" [restrict]="'[ -￮]'" [maxChars]="30" [tabindex]="0"
                      [displayCountField]="false" [fullOnly]="true" [(ngModel)]="kymw0B00Model.guideGoodsName"
                      [forcedEnabledMode]="'true'" style="width: 32rem">
                    </app-text-input>
                  </div>
                  <label class="list-input-title">所属</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_ImageBelongID" #cmb_ImageBelongID
                      [subid]="'cmb_ImageBelongID'" [codeDiv]="'ct365'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.imageBelongID" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">商品案内用規格名</label>
                  <div class="list-input-content">
                    <app-text-input id="txti_GuideStandardName" class="guide-standard-name" #txti_GuideStandardName
                      [subid]="'txti_GuideStandardName'" [restrict]="'[ -￮]'" [maxChars]="15" [tabindex]="0"
                      [displayCountField]="false" [fullOnly]="true" [(ngModel)]="kymw0B00Model.guideStandardName"
                      [forcedEnabledMode]="'true'" style="width: 17rem">
                    </app-text-input>
                  </div>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 650px;">
                  <label class="list-input-title">調理指示</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_ProcessInstruct" #cmb_ProcessInstruct
                      [subid]="'cmb_ProcessInstruct'" [codeDiv]="'ct368'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.processInstruct" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">調理例掲載区分</label>
                  <div class="list-input-content">
                    <label><input type="checkbox" id="chk_CookingExPublish" [(ngModel)]="kymw0B00Model.cookingExPublish"
                      forcedEnabledMode="true" [tabindex]="0" />掲載あり</label>
                  </div>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">備考</label>
                <div class="list-input-content">
                  <app-text-input id="txti_Remarks" #txti_Remarks [subid]="'txti_Remarks'" [restrict]="'[ -￮]'"
                    [tabindex]="0" [displayCountField]="false" [fullOnly]="true" [(ngModel)]="kymw0B00Model.remarks"
                    [forcedEnabledMode]="'true'" [maxChars]="128">
                  </app-text-input>
                  <label class="enable_multsel">※複数検索可</label>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list">
                  <label class="list-input-title">料理分類</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_CookingDiv" #cmb_CookingDiv
                      [subid]="'cmb_CookingDiv'" [codeDiv]="'ct369'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.cookingDiv" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">料理名</label>
                <div class="list-input-content">
                  <app-text-input id="txti_CookingName" #txti_CookingName [subid]="'txti_CookingName'"
                    [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false" [fullOnly]="true"
                    [(ngModel)]="kymw0B00Model.cookingName" [forcedEnabledMode]="'true'" [maxChars]="20" style="width: 376px">
                  </app-text-input>
                  <label class="enable_multsel">※複数検索可</label>
                </div>
                <label class="list-input-title">材料名</label>
                <div class="list-input-content">
                  <app-text-input id="txti_MaterialName" #txti_MaterialName [subid]="'txti_MaterialName'"
                    [restrict]="'[ -￮]'" [tabindex]="0" [displayCountField]="false" [fullOnly]="true"
                    [(ngModel)]="kymw0B00Model.materialName" [forcedEnabledMode]="'true'" [maxChars]="20" style="width: 376px">
                  </app-text-input>
                  <label class="enable_multsel">※複数検索可</label>
                </div>
                <label class="list-input-title">キーワード</label>
                <div class="list-input-content">
                  <app-text-input id="txti_KeyWord" #txti_KeyWord [subid]="'txti_KeyWord'" [restrict]="'[ -￮]'"
                    [tabindex]="0" [displayCountField]="false" [fullOnly]="true" [(ngModel)]="kymw0B00Model.keyWord"
                    [forcedEnabledMode]="'true'" [maxChars]="128">
                  </app-text-input>
                  <label class="enable_multsel">※複数検索可</label>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">催事・季節</label>
                <div class="list-input-content">
                  <app-code-combo-box id="cmb_EventID" #cmb_EventID [subid]="'cmb_EventID'"
                    [codeDiv]="'ct370'" [tabindex]="0" [labelField]="'codeValueName'" [forcedEnabledMode]="'true'"
                    [(ngModel)]="kymw0B00Model.eventID" style="width: 17rem">
                  </app-code-combo-box>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 650px;">
                  <label class="list-input-title">撮影内容区分</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_PhotoContentsDiv" #cmb_PhotoContentsDiv
                      [subid]="'cmb_PhotoContentsDiv'" [codeDiv]="'ct372'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.photoContentsDiv" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">作成指示者</label>
                  <div class="list-input-content">
                    <select class="combo-box-normal" id="cmb_ImageInstructUser" [tabindex]="0"
                      forcedEnabledMode="true" [(ngModel)]="kymw0B00Model.imageInstructUser">
                      <ng-template ngFor let-item [ngForOf]="kymw0B00Model.imageInstructUserList">
                        <option value="{{item.code}}">{{item.lbl}}</option>
                      </ng-template>
                    </select>
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">撮影場所</label>
                  <div class="list-input-content">
                    <app-studio-master-combo-box class="combo-box-normal" id="cmb_PhotoStudio"
                      [subid]="'cmb_PhotoStudio'" [tabindex]="0" [forcedEnabledMode]="'true'"
                      [(ngModel)]="kymw0B00Model.photoStudio" style="width: 17rem">
                    </app-studio-master-combo-box>
                  </div>
                </div>
              </div>
              <div class="column-list">
                <label class="list-input-title">作成指示日</label>
                <div class="list-input-content">
                  <wj-input-date #dtf_ImageInstructDateStart id="dtf_ImageInstructDateStart" format="yyyy/MM/dd"
                    [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate" forcedEnabledMode="true"
                    [(text)]="kymw0B00Model.imageInstructDateStart" [tabindex]="0" style="width: 9rem">
                  </wj-input-date>
                  <label>～</label>
                  <wj-input-date #dtf_ImageInstructDateEnd id="dtf_ImageInstructDateEnd" format="yyyy/MM/dd"
                    [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate" forcedEnabledMode="true"
                    [(text)]="kymw0B00Model.imageInstructDateEnd" [tabindex]="0" style="width: 9rem">
                  </wj-input-date>
                  <button id="btn_ClearImageInstructDate" class="btn-tartiary" [tabindex]="0"
                    forcedEnabledMode="true" (click)="eventClearImageInstructDateHandler()">クリア</button>
                </div>
                <label class="list-input-title">画像ファイル登録日</label>
                <div class="list-input-content">
                  <wj-input-date #dtf_FileRegistDateStart id="dtf_FileRegistDateStart" format="yyyy/MM/dd"
                    [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate" forcedEnabledMode="true"
                    [(text)]="kymw0B00Model.fileRegistDateStart" [tabindex]="0" style="width: 9rem">
                  </wj-input-date>
                  <label>～</label>
                  <wj-input-date #dtf_FileRegistDateEnd id="dtf_FileRegistDateEnd" format="yyyy/MM/dd"
                    forcedEnabledMode="true" [isRequired]="false" [value]="null" [min]="minDate" [max]="maxDate"
                    [(text)]="kymw0B00Model.fileRegistDateEnd" [tabindex]="0" style="width: 9rem">
                  </wj-input-date>
                  <button id="btn_ClearFileRegistDate" class="btn-tartiary" [tabindex]="0" forcedEnabledMode="true"
                    (click)="eventClearFileRegistDateHandler()">クリア</button>
                </div>
                <label class="list-input-title">画像ステータス</label>
                <div class="list-input-content">
                  <app-code-combo-box id="cmb_ImageStatus" #cmb_ImageStatus
                    [subid]="'cmb_ImageStatus'" [forcedEnabledMode]="'true'" [codeDiv]="'ctp260'" [tabindex]="0"
                    [labelField]="'codeValueName'" [(ngModel)]="kymw0B00Model.imageStatus" style="width: 17rem">
                  </app-code-combo-box>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 650px;">
                  <label class="list-input-title">画像作成指示</label>
                  <div class="list-input-content">
                    <select class="combo-box-normal" id="cmb_ImageInstructDiv" #cmb_ImageInstructDiv
                      [tabindex]="0" forcedEnabledMode="true" [(ngModel)]="kymw0B00Model.imageInstructDiv" style="width: 17rem">
                      <ng-template ngFor let-item [ngForOf]="kymw0B00Model.imageInstructDivList">
                        <option value="{{item.code}}">{{item.lbl}}</option>
                      </ng-template>
                    </select>
                  </div>
                  <label class="list-input-title">バイヤーコード</label>
                  <div class="list-input-content">
                    <app-code-combo-box id="cmb_BuyerCode" #cmb_BuyerCode
                      [subid]="'cmb_BuyerCode'" [codeDiv]="'ct357'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.buyerCode">
                    </app-code-combo-box>
                  </div>
                </div>
                <div class="column-list">
                  <label class="list-input-title">画像使用可否</label>
                  <div class="list-input-content">
                    <select class="combo-box-normal" id="cmb_ImageEnabledDiv" #cmb_ImageEnabledDiv
                      [tabindex]="0" forcedEnabledMode="true" [(ngModel)]="kymw0B00Model.imageEnableDiv" style="width: 8rem">
                      <ng-template ngFor let-item [ngForOf]="kymw0B00Model.imageEnableDivList">
                        <option value="{{item.code}}">{{item.lbl}}</option>
                      </ng-template>
                    </select>
                  </div>
                  <label class="list-input-title">出力/未出力選択</label>
                  <div class="list-input-content">
                    <select class="combo-box-normal" id="cmb_OutputFlg" #cmb_OutputFlg
                      [tabindex]="0" forcedEnabledMode="true" [(ngModel)]="kymw0B00Model.outputFlg" style="width: 8rem">
                      <ng-template ngFor let-item [ngForOf]="kymw0B00Model.outputFlgList" >
                        <option value="{{item.code}}">{{item.lbl}}</option>
                      </ng-template>
                    </select>
                  </div>
                </div>
              </div>
              <div class="block-row">
                <div class="column-list" style="width: 650px;">
                  <label class="list-input-title" [style.display]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'hidden' : 'none'">
                    C2PFステータス</label>
                  <div class="list-input-content" [style.display]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'hidden' : 'none'">
                    <app-code-combo-box id="cmb_C2pfStatus" #cmb_C2pfStatus
                      [subid]="'cmb_C2pfStatus'" [codeDiv]="'ctp257'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.c2pfStatus">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">繰越</label>
                  <div class="list-input-content">
                    <label><input type="checkbox" id="chk_CarriedForward" [(ngModel)]="kymw0B00Model.carriedForward"
                      forcedEnabledMode="true" [tabindex]="0" />含む</label>
                  </div>
                  <label class="list-input-title">変更前撮影予定日</label>
                  <div class="list-input-content">
                    <label><input type="checkbox" id="chk_PhotographingChangeSchedule" [(ngModel)]="kymw0B00Model.photographingChangeSchedule"
                      forcedEnabledMode="true" [tabindex]="0" />含む</label>
                  </div>

                </div>
                <div class="column-list">
                  <label class="list-input-title" [style.display]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'hidden' : 'none'">
                    画像使用方法</label>
                  <div class="list-input-content" [style.display]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'hidden' : 'none'">
                    <app-code-combo-box id="cmb_ImageUse" #cmb_ImageUse
                      [subid]="'cmb_ImageUse'" [codeDiv]="'ctp258'" [tabindex]="0" [labelField]="'codeValueName'"
                      [forcedEnabledMode]="'true'" [(ngModel)]="kymw0B00Model.imageUse" style="width: 17rem">
                    </app-code-combo-box>
                  </div>
                  <label class="list-input-title">C2PF対象</label>
                  <div class="list-input-content">
                    <label><input type="checkbox" id="chk_C2pfTarget" [(ngModel)]="kymw0B00Model.c2pfTarget"
                      forcedEnabledMode="true" [tabindex]="0" />含む</label>
                  </div>
                  <label class="list-input-title" [style.display]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'hidden' : 'none'">
                    取引先コメント</label>
                  <div class="list-input-content" [style.display]="kymw0B00Model.c2pfSearchVisibleFlg === '1' ? 'hidden' : 'none'">
                    <label><input type="checkbox" id="chk_SupplierComment" [(ngModel)]="kymw0B00Model.supplierComment"
                      forcedEnabledMode="true" [tabindex]="0" />含む</label>
                  </div>
                </div>
              </div>
            </div>
          </wj-tab>
          <wj-tab>
            <a>リスト検索</a>
            <div class="block-row">
              <div class="column-list">
                <label class="list-input-title">Ｐコードリスト</label>
                <div class="list-input-content" style="height: calc(75vh - 90px);">
                  <textarea id="txta_PcodeList" class="list-input-content pcode" forcedEnabledMode="true"
                  plessInputTextSub [restrict]="'[P0-9\n]'" wordWrap="true" [tabindex]="0"
                  [(ngModel)]="kymw0B00Model.pcodeList"></textarea>
                </div>
              </div>
              <div class="element-column">
                <label>・１行１件のＰコードを入力してください。</label>
                <label>・一度に入力できるＰコードは最大1000件までとします。</label>
              </div>
            </div>
          </wj-tab>
        </wj-tab-panel>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_ConditionClear" class="btn-tartiary" (click)="eventConditionClearHandler(null)"
            [tabindex]="0" forcedEnabledMode="true">条件クリア</button>
          <button id="btn_Search" class="btn-primary" (click)="eventSearchHandler(null)" [tabindex]="0"
            forcedEnabledMode="true">検索</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>